import { render } from "./ImportLogList.vue?vue&type=template&id=4bc23adc"
import script from "./ImportLogList.vue?vue&type=script&lang=js"
export * from "./ImportLogList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__